import React, { useEffect } from "react";
import DropdownField from "components/FormFields/DropdownField";
import RadioGroup from "components/FormFields/RadioGroup";
import PostOfficeCard from "components/PostOfficeCard";
import isEmpty from "lodash/isEmpty";
import map from "lodash/map";

const PostOfficePickUp = props => {
  const {
    regions,
    fetchPostOfficeDeliverySlots,
    onRegionChange,
    onStoreChange,
    deliverySlots,
    themeColors
  } = props;

  useEffect(() => {
    if (!regions.length) {
      const params = {
        portin: false,
        selectedRegion: null,
        type: "sim-only"
      };
      fetchPostOfficeDeliverySlots && fetchPostOfficeDeliverySlots(params);
    }
    // eslint-disable-next-line
  }, [regions]);
  const deliverySlotOptions = map(deliverySlots, slot => {
    return {
      ...slot,
      label: <PostOfficeCard {...slot} />,
      value: slot.id
    };
  });

  return (
    <>
      <DropdownField
        required
        field="region"
        label="delivery_info_select_your_region"
        options={regions}
        onChange={onRegionChange}
        themeColors={themeColors}
      />

      {!isEmpty(deliverySlotOptions) && (
        <RadioGroup
          required
          options={deliverySlotOptions}
          onChange={onStoreChange}
          field="post_office_id"
          label="delivery_info_select_post_office_to_collect"
          render={deliverySlot => deliverySlot.label}
          themeColors={themeColors}
        />
      )}
    </>
  );
};

PostOfficePickUp.defaultProps = {
  deliverySlots: [],
  regions: []
};

export default PostOfficePickUp;
